export default "__VITE_ASSET__CC3O5_ES__"